import React from "react";
import RegistrationRequest from "./RegistrationRequest";
import {RegistrationHeaderName} from "./RegistrationHeader";

export default ({
    $locale,
    eventKey,
    moduleAuth = {},
    eventName,
    registrationFields,
    participationType = 'online',
    customDescription,
    hideLoginSubtitle,
    authRequired,
    hideInfoBlock,
    onWindowResize,
    registrationType,
}) => {
    const participationTypeSet = localStorage.getItem(`participationType_${eventKey}`) || '';

    const handleRegistration = () => {};

    return (
        <RegistrationHeaderName
            $locale={$locale}
            eventName={eventName}
            customDescription={customDescription}
            hideLoginSubtitle={hideLoginSubtitle}
            authRequired={authRequired}
            hasRegistrationFields={registrationFields.length > 1}
            hideInfoBlock={hideInfoBlock}
        >
            <RegistrationRequest
                $locale={$locale}
                eventKey={eventKey}
                allowAnonymousLogin={!moduleAuth?.require && moduleAuth?.anonymous}
                fields={registrationFields}
                onSuccess={handleRegistration}
                participationType={participationType}
                participationTypeSet={participationTypeSet}
                authRequired={authRequired}
                hasRegistrationFields={registrationFields.length > 1}
                onWindowResize={onWindowResize}
                registrationType={registrationType}
                isGuestLogin
            />
        </RegistrationHeaderName>
    )
}
